import { IOption } from '../../../../components/Select/Select';
import { IFilterOptions } from '../Ledger';

export const getFilterOptionsFromSet = (
  filterName: 'eventNames' | 'payeers' | 'types',
  filterOptions: IFilterOptions
): IOption[] =>
  Array.from(filterOptions[filterName])
    .filter((item: string) => item)
    .map((item: string) => ({ label: item, value: item }));
